import { render, staticRenderFns } from "./SeparateGuardians.vue?vue&type=template&id=45ea7455"
import script from "./SeparateGuardians.vue?vue&type=script&lang=js"
export * from "./SeparateGuardians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports